import { render, staticRenderFns } from "./login.vue?vue&type=template&id=edf70ddc&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
import style0 from "./login.vue?vue&type=style&index=0&id=edf70ddc&prod&lang=scss&scoped=true"
import style1 from "./login.vue?vue&type=style&index=1&id=edf70ddc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf70ddc",
  null
  
)

export default component.exports